import axios from 'axios';
import auth from '@/api/auth';


export default {
    getUserInfo() {
        var jwtToken = auth.auth.getSignInUserSession().getAccessToken().jwtToken;
        var idToken = auth.auth.getSignInUserSession().getIdToken().decodePayload();
        const USERINFO_URL = 'https://' + auth.auth.getAppWebDomain() + '/oauth2/userInfo';
        var requestData = {
            headers: {
                'Authorization': 'Bearer ' + jwtToken
            }
        }
        return axios.get(USERINFO_URL, requestData).then(response => {
            response.data.groups = idToken["cognito:groups"];
            localStorage.setItem('user_info', JSON.stringify(response.data));
            return response.data;
        });
    }
}